import { getInfo, login, logout } from '@/api/login'
import { getToken, removeToken, setToken } from '@/utils/auth'
import { default as api } from '../../utils/api'
import store from '../../store'
import router from '../../router'
import global from '../../components/global'

const user = {
    state: {
        loginName: "",
        nickname: "",
        userId: "",
        role: '',
        isAdmin: '0',
        permissions: [],
    },
    mutations: {
        SET_USER: (state, userInfo) => {
            state.loginName = userInfo.loginName;
            state.nickname = userInfo.loginName;
            state.userId = userInfo.id;
            state.permissions = userInfo.permissionList;
            state.isAdmin = userInfo.isAdmin;
            state.role = userInfo.isAdmin == "1" ? "系统管理员" : "测试";
        },
        RESET_USER: (state) => {
            state.loginName = "";
            state.nickname = "";
            state.userId = "";
            state.role = '';
            state.permissions = [];
            state.isAdmin = '0';
        }
    },
    actions: {
        // 登录
        Login({ commit, state }, loginForm) {
            return new Promise((resolve, reject) => {
                api({
                    url: global.host + "/login/loginauth",
                    method: "post",
                    data: loginForm
                }).then(data => {
                    if (data.result === true) {
                        //cookie中保存前端登录状态
                        setToken();
                    }
                    resolve(data);
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 获取用户信息
        GetInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                api({
                    url: global.host + '/user/getInfo',
                    method: 'post',
                    data: {}
                }).then(data => {
                    if (data.result) {
                        //储存用户信息
                        commit('SET_USER', data.data);
                        //cookie保存登录状态,仅靠vuex保存的话,页面刷新就会丢失登录状态
                        setToken();
                        //生成路由
                        let userPermission = data.data.menuList;
                        let isAdmin = data.data.isAdmin;
                        window.sessionStorage.systName = data.data.name;
                        window.sessionStorage.sysOrgId = data.data.organizationId;
                        window.sessionStorage.userInfo = JSON.stringify(data.data);
                        store.dispatch('GenerateRoutes', { "isAdmin": isAdmin, "menus": userPermission }).then(() => {
                            //生成该用户的新路由json操作完毕之后,调用vue-router的动态新增路由方法,将新路由添加
                            router.addRoutes(store.getters.addRouters)
                        })
                    } else {

                    }
                    resolve(data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 登出
        LogOut({ commit }) {
            return new Promise((resolve) => {
                api({
                    url: global.host + "/login/logout",
                    method: "post"
                }).then(data => {
                    commit('RESET_USER')
                    removeToken()
                    resolve(data);
                }).catch(() => {
                    commit('RESET_USER')
                    removeToken()
                })
            })
        },
        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('RESET_USER')
                removeToken()
                resolve()
            })
        }
    }
}
export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js